import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ticketing-resumen-albaran',
  templateUrl: './resumen-albaran.component.html',
  styleUrls: ['./resumen-albaran.component.scss'],
})
export class ResumenAlbaranComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
